import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccSeatDisplayText = {
    labelFormat: '${rowLabel}${seatLabel}',
    groupFormat: '${firstSeatLabel}–${lastSeatLabel}',
    groupSeparator: ', ',
    placeholderLabel: {
        text: '— ',
        className: 'v-seat-summary-placeholder-label'
    },
    areaNameSeparator: ', '
};
export const occSeatDisplayTextValidator = Validator.object({
    labelFormat: nonEmptyStringValidator,
    groupFormat: nonEmptyStringValidator,
    groupSeparator: nonEmptyStringValidator,
    placeholderLabel: displayTextLabelValidator,
    areaNameSeparator: nonEmptyStringValidator
});
